// extracted by mini-css-extract-plugin
export default {"wrapper":"BingoPrizeNotification-module__wrapper","overlayButton":"BingoPrizeNotification-module__overlayButton"};